'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaderCoordinates = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getHeaderCoordinates = exports.getHeaderCoordinates = function getHeaderCoordinates(oneValueDimensions) {
  return R.reduce(function (acc, dim) {
    return R.assoc(dim.id, R.path(['values', 0, 'id'], dim), acc);
  }, {}, oneValueDimensions);
};